module.exports = __webpack_public_path__ + "static/media/ST7.60eb1652.mp3";